export const generateThumbnail = (videoUrl: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = videoUrl;
    video.muted = true;
    video.preload = 'metadata';
    // 移除 crossOrigin 设置，避免本地文件跨域问题
    // video.crossOrigin = 'anonymous';
    
    // 设置超时
    const timeoutId = setTimeout(() => {
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      video.removeEventListener('error', handleError);
      reject(new Error('Thumbnail generation timeout'));
    }, 5000);
    
    const handleError = (error: Event) => {
      clearTimeout(timeoutId);
      reject(new Error('Video loading error'));
    };
    
    const handleLoadedMetadata = () => {
      clearTimeout(timeoutId);
      
      // 创建canvas来绘制缩略图
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      if (!ctx || !video.videoWidth || !video.videoHeight) {
        reject(new Error('Invalid video dimensions'));
        return;
      }
      
      // 设置canvas尺寸（保持视频比例，但限制最大尺寸以提高性能）
      const maxWidth = 200;
      const maxHeight = 300;
      let width = video.videoWidth;
      let height = video.videoHeight;
      
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
      }
      
      canvas.width = width;
      canvas.height = height;
      
      // 绘制视频帧到canvas
      const drawFrame = () => {
        try {
          ctx.drawImage(video, 0, 0, width, height);
          const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.7); // 降低质量以提高性能
          resolve(thumbnailUrl);
        } catch (error) {
          reject(error);
        }
      };
      
      // 尝试在多个时间点获取帧
      let attempts = 0;
      const maxAttempts = 3;
      
      const tryDrawFrame = () => {
        if (attempts >= maxAttempts) {
          drawFrame();
          return;
        }
        
        // 选择不同的时间点（避免黑屏）
        const timePoints = [0.5, 1, 2];
        video.currentTime = timePoints[attempts] || 1;
        
        const seekHandler = () => {
          video.removeEventListener('seeked', seekHandler);
          drawFrame();
        };
        
        video.addEventListener('seeked', seekHandler);
        attempts++;
        
        // 如果seek超时，直接绘制当前帧
        setTimeout(() => {
          video.removeEventListener('seeked', seekHandler);
          drawFrame();
        }, 500);
      };
      
      tryDrawFrame();
    };
    
    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    video.addEventListener('error', handleError);
  });
};